import { Tab, TabList, Tabs, TabsProps } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

export type NewsTab = 'news' | 'governance'

interface Props extends Omit<TabsProps, 'children' | 'index' | 'onChange'> {
  value: NewsTab
  onChange(tab: NewsTab): void
}

// Opérationnelle / Gouvernance, the two feeds of the news (ACTU-01), on the
// dashboard and in a circle's panel (#109). One component so both read the
// same: each tab takes the color of its tension badge (teal for operational,
// purple for governance, threadTypeBadge), with a darker text in light theme
// (Yohan, 25/09).
export default function NewsTabs({ value, onChange, ...tabsProps }: Props) {
  const { t } = useTranslation()
  return (
    <Tabs
      variant="soft-rounded"
      size="sm"
      {...tabsProps}
      index={value === 'governance' ? 1 : 0}
      onChange={(index) => onChange(index === 1 ? 'governance' : 'news')}
    >
      <TabList>
        <Tab
          color="gray.600"
          _selected={{ bg: 'teal.100', color: 'teal.800' }}
          _dark={{
            color: 'gray.300',
            _selected: { bg: 'teal.700', color: 'teal.50' },
          }}
        >
          {t('DashboardNews.operational')}
        </Tab>
        <Tab
          color="gray.600"
          _selected={{ bg: 'purple.100', color: 'purple.800' }}
          _dark={{
            color: 'gray.300',
            _selected: { bg: 'purple.700', color: 'purple.50' },
          }}
        >
          {t('DashboardNews.governance')}
        </Tab>
      </TabList>
    </Tabs>
  )
}
